export default __webpack_public_path__ + "static/media/dharmaloka college.6aff9d09.png";